// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e1d881a7","455":"0f4c91e7","977":"9e25af31"}[chunkId] + ".chunk.js";
};